<template>
  <!--  作品分配  -->
  <el-dialog
    :visible.sync="workDiolog"
    title="专家评分作品"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleBeforeColse"
    :close="handleColse"
    style='width: 100%'
    class="dialiogClass"
  >
<!--    <el-row :gutter="10" class="mb8">-->
<!--      <el-col :span="1.5">-->
<!--        <el-button-->
<!--          type="info"-->
<!--          icon="el-icon-edit"-->
<!--          size="mini"-->
<!--          @click="handleRevert"-->
<!--          >驳回</el-button-->
<!--        >-->
<!--        <el-button type="info" icon="el-icon-edit" size="mini" @click="toVoid"-->
<!--          >作废</el-button-->
<!--        >-->
<!--      </el-col>-->
<!--    </el-row>-->
    <!-- 作品列表 -->
    <el-table
      ref="worksTable"
      :data="worksList"
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
        align="center"
        :reserve-selection="true"
      />
      <el-table-column label="作品名称" align="center" prop="worksName" />
      <el-table-column label="作品评语" align="center" prop="remark" />
      <el-table-column label="作品评分" align="center" prop="grade" />
    </el-table>

    <pagination
      style="text-align: center"
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"/>
  </el-dialog>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
  components: {
    Pagination,
  },
  props: ["workDiolog","formType","flowId"],
  data() {
    return {
      //关联表数据
      connectDataList: [],
      // 加载动画显示
      loading: true,
      selectedExpertId: undefined,
      //选中作品数据
      selectWorks: [],
      selectWorkId: [],
      //列表数据
      worksList: [],
      // 表单参数
      form: {},

      //列表数据总数
      total: 0,
      markType: undefined,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        siteId: this.siteId,
        exportId: undefined,
        worksName: undefined,
      },
      dialogStyle: "50% !important",
    };
  },
  beforeMount() {
    // 添加判断方法
    let mobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (mobile) {
      this.dialogStyle = "100% !important";
    }
  },
  mounted() {
    var urlRule = this.siteURL + "/actuator/rule/getInfoBYSiteId";
    this.axios
      .get(urlRule, { params: { siteId: this.siteId } })
      .then((response) => {
        if (response.data.code === 200) {
          this.markType = response.data.data.ruleId;
        }
      });
  },
  methods: {
    /** 关闭dialog之前的回调 */
    handleBeforeColse() {
      this.selectWorks = [];
      this.$emit("update:workDiolog", false);
    },
    /** 关闭dialog回调 */
    handleColse() {
      this.selectWorks = [];
      this.$emit("update:workDiolog", false);
    },

    /** 获取列表数据 */
    getList(id) {
      var url = this.siteURL + "/actuator/workExport/list";
      this.selectedExpertId = id;
      this.queryParams.exportId = id;
      this.queryParams.worksType = this.formType;
      this.queryParams.delFlag = this.flowId;
      this.axios.get(url, { params: this.queryParams }).then((response) => {
        if (response.data.code === 200) {
          this.worksList = response.data.rows;
          this.total = response.data.total
          this.worksList.forEach(function (item, index) {
            let worksData = JSON.parse(item.worksName);
            item.worksName = worksData.workName;
          });
        }
      });
    },

    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams.worksName = undefined;
      this.getList();
    },
    /** 驳回操作 */
    handleRevert() {
      if (this.selectWorks.length === 0) {
        this.$message({
          type: "info",
          message: "还未选择驳回作品，请先选择作品",
        });
        return;
      }
      this.$confirm(
        "此操作会使此专家这个作评评分清空，需重新评审作品, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          var url = this.siteURL + "/actuator/workExport/revertGrade";
          //重置上传对象
          this.reset();
          this.form.ids = this.selectWorks;
          this.axios.post(url, this.form).then((response) => {
            if (response.data.code === 200) {
              this.$message({
                message: "驳回成功",
                type: "success",
              });
              this.selectWorkId.forEach((item) => {
                this.updateFinalyGrade(item);
              });
              this.ids = [];
              this.$refs.worksTable.clearSelection();
              this.reset();
              this.$emit("update:workDiolog", false);
              this.$emit("getTableList");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消驳回",
          });
        });
    },
    /** 驳回操作 */
    toVoid() {
      if (this.selectWorks.length === 0) {
        this.$message({
          type: "info",
          message: "还未选择作废作品，请先选择作品",
        });
        return;
      }
      this.$confirm("此操作会使此作品成绩作废, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var url = this.siteURL + "/actuator/workExport/toVoid";
          //重置上传对象
          this.reset();
          this.form.ids = this.selectWorks;
          this.axios.post(url, this.form).then((response) => {
            if (response.data.code === 200) {
              this.$message({
                message: "作废成功",
                type: "success",
              });
              this.selectWorkId.forEach((item) => {
                this.updateFinalyGrade(item);
              });
              this.ids = [];
              this.$refs.worksTable.clearSelection();
              this.reset();
              this.$emit("update:workDiolog", false);
              this.$emit("getTableList");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消作废操作",
          });
        });
    },
    updateFinalyGrade(id) {
      //回去根据评分方法求得的最终成绩
      var workExport = { contWorkExportList: [{ workId: undefined }] };
      var url = this.siteURL + "/actuator/workExport/getAvgGrade";
      workExport.markType = this.markType;
      workExport.contWorkExportList[0].workId = id;
      this.axios.post(url, workExport).then((response) => {
        if (response.data.code === 200) {
          var data = { contWorksList: [] };
          var workUrl = this.baseURL + "/actuator/works/updateGrade";
          //循环生成对象
          response.data.data.forEach((element) => {
            data.contWorksList.push({
              id: element.workId,
              finalGrade: element.grade,
            });
          });
          this.axios.post(workUrl, data).then((response) => {
            if (response.data.code === 200) {
              console.log(response);
            }
          });
        }
      });
    },
    /** 选择作品改变 */
    handleSelectionChange(selection) {
      this.selectWorks = selection.map((item) => item.id);
      this.selectWorkId = selection.map((item) => item.workId);
    },
    /** 表单重置 */
    reset() {
      this.form = {
        id: undefined,
        workId: undefined,
        exportId: undefined,
        grade: undefined,
        status: "0",
        remark: undefined,
        sort: undefined,
        createTime: undefined,
        createBy: undefined,
        updateTime: undefined,
        updateBy: undefined,
        delFlag: undefined,
        contWorkExportList: [],
        contWorkRecordList: [],
        ids: [],
      };
    },
  },
};
</script>
<style>
@media screen and (max-width: 1200px) {
  .el-dialog {
    width: 100% !important;
  }
 .el-message-box{
    width:365px
  }
}
.dialiogClass .el-dialog .el-dialog__body {
    padding: 30px 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ExpertRatingDialog.vue